"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutSectionRenderer = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_grid_system_1 = require("react-grid-system");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var isHiddenStyle = { height: 0, width: 0, overflow: "hidden", flex: 0 };
var defaultStyle = {};
exports.DashboardLayoutSectionRenderer = function (props) {
    var children = props.children, className = props.className, debug = props.debug, isHidden = props.isHidden;
    var style = isHidden ? isHiddenStyle : defaultStyle;
    return (react_1.default.createElement(react_grid_system_1.Row, { className: classnames_1.default(["gd-fluidlayout-row", "s-fluid-layout-row", className], {
            "gd-fluidlayout-row-debug": debug,
        }), style: style }, children));
};
//# sourceMappingURL=DashboardLayoutSectionRenderer.js.map